<template>
  <div>
    <div class="loan-agreement-wrapper">
      <iframe
        src="https://jydpro.jinr.com/uploadsFiles/jyd/static/agreement.pdf"
        frameborder="0"
        class="pdf-wrapper"
      ></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'loan-agreement',
  data() {
    return {
      title: '借款合同'
    };
  },
  mounted() {
    // this.$eventBus.$emit('listBarTitle', this.title);
  }
};
</script>
<style lang="less" scoped>
.loan-agreement-wrapper {
  width: 100%;
  height: 100%;
}
.pdf-wrapper {
  width: 100%;
  height: 13rem;
}
</style>
